import React, { FC, useContext } from 'react';

import { MDText } from 'i18n-react';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import {
  REVIEW_AUTHOR_MAX_LENGTH,
  REVIEW_BODY_MAX_LENGTH,
  REVIEW_TITLE_MAX_LENGTH,
  truncate,
} from 'Utilities/helpers';

import { TrustpilotCardProps } from '../trustpilotCommon/Trustpilot.types';
import LocalTexts from '../trustpilotCommon/TrustpilotTexts.json';
import { useTrustpilotCardHighlight } from '../trustpilotCommon/useTrustpilotCardHighlight';
import { useTrustpilotModal } from '../trustpilotCommon/useTrustpilotModal';

import styles from './TrustpilotCardBespoke.scss';

const LocalT = new MDText(LocalTexts);

export const TrustpilotCardBespoke: FC<TrustpilotCardProps> = ({
  brand = null,
  cardTitleTruncationLength = REVIEW_TITLE_MAX_LENGTH,
  cardTruncationLength = REVIEW_BODY_MAX_LENGTH,
  review,
}) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { display_name: displayName } = brand || vehicle?.make || {};

  const { author, body } = review;

  const data = {
    displayName,
    review,
  };

  const { HighlightedBody, HighlightedTitle } = useTrustpilotCardHighlight({
    cardTitleTruncationLength,
    cardTruncationLength,
    ...data,
  });

  const { modalWrapper, triggerModalOpen } = useTrustpilotModal(data);

  return (
    <div className={styles.component}>
      <div className={styles.starRating}>{LocalT.translate('rating')}</div>
      <h3 className={styles.title}>{ HighlightedTitle }</h3>
      <div>
        { HighlightedBody }
        { ' ' }
        { body && body.length > cardTruncationLength ? (
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              triggerModalOpen();
            }}
          >
            {LocalT.translate('showMore')}
          </a>
        ) : null}
        { modalWrapper }
      </div>
      <div className={styles.cardFooter}>
        <p>{truncate(author, REVIEW_AUTHOR_MAX_LENGTH)}</p>
      </div>
    </div>
  );
};
